import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import { SaveErrorPropType } from '../../../../proptypes/errors';

const ProvisionMonthSelect = ({ ...other }) => {
    // let the user choose between the last six months
    // make sure that exp. 2024-01 is displayed as "Januar 2024"
    // and 2024-02 as "Februar 2024" etc.

    const options = useMemo(() => {
        const currentMonthBase = new Date();
        currentMonthBase.setDate(1); // Set to the first day of the current month
        currentMonthBase.setHours(0, 0, 0, 0); // Reset time to midnight

        // Generate the array of date objects for the last six months
        const lastSixMonthsDates = Array.from({ length: 6 }, (_, i) => {
            const date = new Date(currentMonthBase);
            date.setMonth(currentMonthBase.getMonth() - i);
            return date;
        });

        return lastSixMonthsDates.map((dateInstance) => {
            // Use 'de-DE' for German month names as implied by "Januar" in comments
            const monthName = dateInstance.toLocaleString('de-DE', { month: 'long' });
            const year = dateInstance.getFullYear();
            const month = (dateInstance.getMonth() + 1).toString().padStart(2, '0'); // getMonth is 0-indexed
            return {
                value: `${year}-${month}`, // Correctly format as YYYY-MM from local date parts
                label: `${monthName} ${year}`, // e.g., "Januar 2024"
            };
        });
    }, []); // Calculate options once on component mount.
          // This makes the list of months stable after initial render.

    return <Select {...other} options={options} keepOrder/>;
};

ProvisionMonthSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    labelId: PropTypes.string,
    onChange: PropTypes.func,
    errors: SaveErrorPropType,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
};

ProvisionMonthSelect.defaultProps = {
    label: null,
    labelId: null,
    onChange: null,
    errors: null,
    fullWidth: false,
    disabled: false,
    loading: false,
};

export default ProvisionMonthSelect;